import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { broadcastMessage, hideMessage } from "../../store/slices/broadcastMessageSlice";
import "bootstrap/dist/css/bootstrap.min.css";
import { X, ArrowClockwise } from "react-bootstrap-icons";

const BroadcastMessage = () => {
  const dispatch = useDispatch();
  const { message, messageSeen } = useSelector((state) => state.broadcastMessage);
  const [showAnimation, setShowAnimation] = useState(true);
  const [isClosing, setIsClosing] = useState(false);
  const [isAnimating, setIsAnimating] = useState(true);
  const animationTimeout = setTimeout(() => {
    setIsAnimating(false);
  }, 5000);
  const broadcastText = message?.[0]?.attributes?.broadcast_msg || "";




  useEffect(() => {
    if (broadcastText && !messageSeen) {
      document.body.classList.add("broadcast-visible");
    } else {
      document.body.classList.remove("broadcast-visible");
    }
  }, [broadcastText, messageSeen]);


  useEffect(() => {
    dispatch(broadcastMessage());

    // Stop animation after 5 seconds (adjust as needed)
    const timeout = setTimeout(() => {
      setShowAnimation(false);
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch]);

  if (!broadcastText || messageSeen) return null;

 
  return (
    <div className="broadcast-message-container bg-primary text-white p-2 overflow-hidden">
    <div className="broadcast-content-wrapper">
      <div 
        className={`broadcast-text fw-bold ${
          isAnimating ? "animate-scroll" : "text-center"
        }`}
      >
        {broadcastText}
      </div>
      
      <button
        className="broadcast-close-btn btn btn-sm ms-3"
        onClick={() => dispatch(hideMessage())}
        aria-label="Close broadcast message"
      >
        {isClosing ? (
          <ArrowClockwise className="spin-animation" size={16} />
        ) : (
          <X size={16} />
        )}
      </button>
    </div>

    <style jsx>{`
      .broadcast-message-container {
        position: relative;
        width: 100%;
      }
      
      .broadcast-content-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      
      .broadcast-text {
        white-space: nowrap;
        padding: 0 1rem;
      }
      
      .animate-scroll {
        display: inline-block;
        animation: scrollOnce 10s linear forwards;
      }
      
      .broadcast-close-btn {
        position: absolute;
        right: 0.5rem;
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        transition: all 0.2s ease;
      }
      
      .broadcast-close-btn:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.3);
        transform: scale(1.1);
      }
      
      .broadcast-close-btn:disabled {
        opacity: 0.8;
      }
      
      .spin-animation {
        animation: spin 1s linear infinite;
      }
      
      @keyframes scrollOnce {
        0% { 
          transform: translateX(100%);
          opacity: 0;
        }
        10% {
          opacity: 1;
        }
        50% { 
          transform: translateX(0); 
        }
        100% { 
          transform: translateX(0); 
        }
      }
      
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
  );
};

export default BroadcastMessage;
